import firebase from "firebase/app";

import { Table } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import { User } from "astrid-firestore/src/api/users/types/User";
import updateUser from "astrid-firestore/src/api/users/updateUser";

import { useProfile } from "../../../authentication/state/profile";
import Form from "../../../forms/components/Form/Form";
import useSimpleForm from "../../../forms/hooks/useSimpleForm";

import CalendarAvailabilityTableRow from "./components/CalendarAvailabilityTableRow";

export default function CalendarAvailabilityForm({ onClose }) {
	const { t } = useTranslation();
	const user = useProfile();

	const { form, error, onSubmit } = useSimpleForm({
		schema: User,
		defaultValues: {
			calendarAvailability: user.calendarAvailability || {},
		},
		onSubmit: (data) => {
			return updateUser(firebase, user.ref, data);
		},
		onSuccess: onClose,
	});

	return (
		<Form.Modal size="small" form={form} error={error} onSubmit={onSubmit} onClose={onClose}>
			<Table celled columns={3}>
				<Table.Header>
					<Table.Row>
						<Table.HeaderCell>{t("day", "Day")}</Table.HeaderCell>
						<Table.HeaderCell>{t("start", "Start")}</Table.HeaderCell>
						<Table.HeaderCell>{t("end", "End")}</Table.HeaderCell>
					</Table.Row>
				</Table.Header>

				<Table.Body>
					<CalendarAvailabilityTableRow day={t("monday", "Monday")} number={1} />

					<CalendarAvailabilityTableRow day={t("tuesday", "Tuesday")} number={2} />

					<CalendarAvailabilityTableRow day={t("wednesday", "Wednesday")} number={3} />

					<CalendarAvailabilityTableRow day={t("thursday", "Thursday")} number={4} />

					<CalendarAvailabilityTableRow day={t("friday", "Friday")} number={5} />

					<CalendarAvailabilityTableRow day={t("saturday", "Saturday")} number={6} />

					<CalendarAvailabilityTableRow day={t("sunday", "Sunday")} number={7} />
				</Table.Body>
			</Table>
		</Form.Modal>
	);
}
